import React, { Component } from 'react'
import PropTypes from 'prop-types'

// CSS
import './../../css/tooltip.css'

class Tooltip extends Component {

	static propTypes = {
		parent: PropTypes.object.isRequired
	}

	constructor(props) {
		super(props)
		this.state = {
			styles: this.calculateLeftSide()
		}
	}

	renderContent(){

		let content = []

		for(let key in this.props.messageObjects){
			if (!this.props.messageObjects.hasOwnProperty(key)) continue
			content.push(<div key={key}>{this.props.messageObjects[key]}</div>)
		}

		return content
	}

	calculateLeftSide(){
		// Left side of the tooltip will be 
		const left = this.props.parent.getBoundingClientRect().width / 2

		return {
			left: left+'px'
		}
	}

	closeTooltip(){
		this.setState({
			styles: {
				...this.state.styles,
				display: 'none'
			}
		})

		if(typeof this.props.closeAction !== 'undefined'){
			this.props.closeAction()
		}
	}

	render() {
		return (
			<div style={this.state.styles} className={`tooltip-dialog ${this.props.type}`} onClick={() => this.closeTooltip()}>
				<div className="tooltip-arrow"></div>
				<div className="content">
					{this.renderContent()}
				</div>
			</div>
		)
	}
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/utils/Tooltip.js